import { ResourceProps } from 'react-admin';
import icon from '@material-ui/icons/Web';
import create from './create';
import edit from './edit';
import list from './list';

const posts: ResourceProps = {
  name: 'pages',
  icon,
  options: { label: 'Páginas' },
  create,
  edit,
  list
};

export default posts;
